import Vue from 'vue';

const trans = Vue.prototype.trans;

const translateDays = (days) => {
  if (days == 'Everyday') {
    return trans('Everyday');
  } else if (days.indexOf('-') !== -1) {
    return days
      .split('-')
      .map((day) => trans(day))
      .join(' - ');
  } else if (days.indexOf(',') !== -1) {
    return days
      .split(',')
      .map((day) => trans(day))
      .join(', ');
  }
  return trans(days);
};

const getDaysOfWeek = (term) => {
  //replace true or false with name of day or 0
  let days = [
    term.m ? 'Mon' : 0,
    term.tu ? 'Tue' : 0,
    term.w ? 'Wed' : 0,
    term.th ? 'Thu' : 0,
    term.f ? 'Fri' : 0,
    term.sa ? 'Sat' : 0,
    term.su ? 'Sun' : 0,
  ];

  //if array_filter = count array means all days is on return Everyday;
  if (days.filter((v) => v === 0).length == 0) {
    return 'Everyday';
  }

  //remove all zeros from start and end
  while (days[0] === 0 || days[days.length - 1] === 0) {
    // While the first or last element is a 0,
    if (days[0] === 0) {
      days.shift();
    } // Remove that first element

    if (days[days.length - 1] === 0) {
      days.pop();
    } // Remove that last element
  }

  //if there is only one array left just show it like "Mon"
  if (days.length == 1) {
    return days[0];
  }

  //if there is more than one array and there is zeros left then show as "Mon, Fri"
  if (days.filter((v) => v === 0).length > 0) {
    days = days.filter(function (val) {
      return val !== 0;
    });

    return days.join(',');
  } else {
    //if there is no zeros left then show from to as "Mon - Fri"
    //get first and last days
    days = [days[0], days[days.length - 1]];
    return days.join('-');
  }
};

//!!This function only returns the data for first term , instade we want to get the data from all terms
//!!If there is more than one session that happen in differetn days, these 2 days should show , not only first session
//!!this code runs 2 times i cheched when i did console log
Vue.filter('formatActivityTime', function (terms) {
  const formatDate = Vue.filter('formatDate');
  const formatTime = Vue.filter('formatTime');

  const time = `${formatTime(terms[0].time_from)} - ${formatTime(
    terms[0].time_to,
  )}`;

  const date = `${formatDate(terms[0].firstDay)} - ${formatDate(
    terms[0].lastDay,
  )}`;

  let weekDays = getDaysOfWeek(terms[0]);
  weekDays = translateDays(weekDays);

  return `${weekDays}, ${time} (${date})`;
});

let currency = window.currency;
Vue.filter('formatActivityPrice', function (term) {
  let child_price = term.child_price;
  //check if its free activity
  if (
    (term.type == 0 && term.session_child_price == 0 && child_price == 0) ||
    (term.type == 1 && term.dropin_child_price == 0 && child_price == 0)
  ) {
    return trans('Free');
  }

  if (term.type === 0) {
    return `${child_price}  ${currency} / ${
      term.spot_count > 0 ? term.spot_count : 0
    } ${trans('Days')}`;
  } else {
    return `${child_price} ${currency} / ${trans('Day')}`;
  }
});
